import { ChangeDetectionStrategy, Component } from '@angular/core';

@Component({
    selector: 'infans-about',
    templateUrl: './about.component.html',
    styleUrls: ['./about.component.css'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false
})
export class AboutComponent {}
